export const USER_ROLES = {
  COMPANY: 'Company',
  FINANCIAL_ADVISOR: 'Advisor',
  CLIENT: 'Investor',
};
